<script lang="ts" setup>
import imageBuyAGiftAnything from '@consumer/assets/images/header-v2/buy-a-gift/anything.png'
import BuyAGift from '../BuyAGift.vue'
</script>

<template>
  <BuyAGift
    path="/buy-a-gift"
    :image="imageBuyAGiftAnything"
    class="user-menu-buy-a-gift"
  >
    <template #title>
      <h2 class="text-3xl !leading-tight text-center">
        Customize & Buy a<br>Gift for Anything
      </h2>
    </template>
  </BuyAGift>
</template>
